(() => {
  if (window.wftPaymentInfoBound) return;
  window.wftPaymentInfoBound = true;
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-payment-open]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.paymentOpen);
      if (!dialog || dialog.open) return;
      const previousOverflow = document.body.style.overflow;
      dialog.showModal();
      document.body.style.overflow = 'hidden';
      dialog.addEventListener('close', () => {
        document.body.style.overflow = previousOverflow;
        if (opener.isConnected) opener.focus();
      }, { once: true });
      return;
    }
    const closer = event.target.closest('[data-payment-close]');
    if (closer) closer.closest('dialog').close();
    if (event.target.matches('.pdp-payment-dialog')) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
    }
  });
})();
